import React from 'react';

export const Logo: React.FC = () => {
  return (
    <div className="flex items-center justify-center mb-8">
      <img
        src="/new_logo_blue.png"
        alt="Portfolio Indexing System"
        className="h-20"
      />

    </div>
  );
};